// extracted by mini-css-extract-plugin
export var col = "salesforce-form-module--col--6f69e";
export var errorMsg = "salesforce-form-module--errorMsg--8d212";
export var form = "salesforce-form-module--form--0e204";
export var position = "salesforce-form-module--position--c478b";
export var row = "salesforce-form-module--row--5c0a7";
export var row3 = "salesforce-form-module--row3--a629d";